import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CheckCircle2, Circle } from "lucide-react";

export const TimelineDialog = ({ tl, onClose }) => (
  <Dialog open={!!tl} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="timeline-dialog">
      <DialogHeader><DialogTitle>Order Timeline</DialogTitle></DialogHeader>
      {tl && (
        <div>
          <p className="text-sm font-semibold text-slate-800">{tl.order?.title}</p>
          <p className="text-xs text-slate-400">{[tl.order?.provider, tl.order?.reference].filter(Boolean).join(" · ")}</p>
          <div className="mt-4">
            {tl.steps.map((s, i) => (
              <div key={s.key} className="flex gap-3" data-testid={`timeline-step-${s.key}`}>
                <div className="flex flex-col items-center">
                  {s.reached ? <CheckCircle2 className="h-5 w-5 text-emerald-500" /> : <Circle className="h-5 w-5 text-slate-300" />}
                  {i < tl.steps.length - 1 && <span className={`w-0.5 flex-1 ${s.reached ? "bg-emerald-200" : "bg-slate-100"}`} style={{ minHeight: 18 }} />}
                </div>
                <div className="pb-4">
                  <p className={`text-sm font-medium ${s.current ? "text-sky-600" : s.reached ? "text-slate-700" : "text-slate-400"}`}>{s.label}{s.current && " • current"}</p>
                  {s.at && <p className="text-xs text-slate-400">{new Date(s.at).toLocaleString("en-GB")}</p>}
                </div>
              </div>
            ))}
          </div>
          {tl.extra?.map((e) => (
            <div key={e.key} className="mt-1 rounded-lg bg-amber-50 p-2 text-xs text-amber-700">{e.label}{e.at ? ` · ${new Date(e.at).toLocaleString("en-GB")}` : ""}</div>
          ))}
          <p className="mt-3 text-[11px] text-slate-400">Timeline reflects the real statuses recorded on this order. Suffle never fabricates carrier tracking.</p>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
